import * as types from './constants';

// Get Dashboard
export const getDashboardRequest = data => (
  { type: types.GET_DASHBOARD_REQUEST, payload: data }
);

export const getDashboardDone = data => (
  { type: types.GET_DASHBOARD_DONE, payload: data }
);

export const getDashboardFailed = errors => (
  { type: types.GET_DASHBOARD_FAILED, payload: errors }
);

// Set Dashboard Popup
export const setDashboardPopup = data => (
  { type: types.SET_DASHBOARD_POPUP, payload: data }
);

export const clearDashboardPopup = () => (
  { type: types.CLEAR_DASHBOARD_POPUP }
);